import { SupervisorCheck } from '../../entities/compliance/supervisor.check';
import { Entity } from "../../entities/entity";
import { Attachment } from "../../entities/shared/attachment";

export const ComplianceQuestionUnique = '00000000-0000-0000-0000-000000000001';

export enum ComplianceAnswerType {
    Confirmation = 'Confirmation',
    Completed = 'Completed',
    Comment = 'Comment',
    Attachment = 'Attachment',
    BeforePhoto = 'BeforePhoto',
    DuringPhoto = 'DuringPhoto',
    AfterPhoto = 'AfterPhoto',
    Signature = 'Signature',
    Form = 'Form',
    File = 'File',
    FormTemplate = 'FormTemplate'
}

export enum MarkComplianceType {
    Code = 'Code',
    Work = 'Work'
}

export type ComplianceAnswerValue = Attachment[] | boolean | string;

export interface WorkComplianceFieldAnswerRequest {
    _id: string;
    fieldName: ComplianceAnswerType;
    value: ComplianceAnswerValue;
    updatedAt?: Date;
}

export interface DeleteComplianceAttachmentRequest {
    _id: string;
    fieldName: ComplianceAnswerType;
    value: Attachment;
    updatedAt?: string;
}


export interface WorkComplianceAnswerRequest {
    workOrderId: string;
    questionId: string;
    codeId?: string;
}

export interface MarkComplianceRequest {
    _id: string;
    isCompleted: boolean;
    type?: MarkComplianceType;
    updatedAt?: string;
}

export interface SupervisorMarkWorkComplianceRequest {
    workComplianceId: string;
    supervisorCheck: SupervisorCheck;
    type: string;
    updatedAt?: string;
    updatedBy: Entity;
}

